// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";

interface TitleProps {
  title: string;
}

const PageTitle: React.FunctionComponent<TitleProps> = (props: TitleProps) => {
  const { title } = props;

  return (
    <>
      <h1 id="title" className="text-center">
        {title}
      </h1>
    </>
  );
};

export default PageTitle;
